import { Route, Routes } from '@angular/router';
import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { AumicoUser } from '../../interfaces/aumico.routing';
import { IPageHeader } from '../../interfaces/pageHeader.interface';
import * as fromActions from './aumico.layout.action';

export const layoutFeatureKey = 'aumicoLayout';
export interface AumicoLayoutState {
    // TODO: breadcrumb must be somehow navigable
    breadcrumb: string;

    /**
     * This property can be subscribed in the router
     * */
    shouldNavigateToRoute: Route | null;
    // TODO: subNavigation must be somehow navigable
    // Usually the router can also react to ngrx navigation
    subNavigation: Routes;
    activeSubNavigation: Route;

    // for back navigation?
    previousPage: string;
    hideFooterOption: boolean;

    // TODO: actionFeedback for footer

    // TODO: to replace navigation service
    routerConfig: Routes;
    primaryNavigation: Routes;
    secondaryNavigation: Routes;
    userNavigation: Route | null;
    activePage: Route;

    // TODO: to display the user
    user: AumicoUser;

    // if true, the sidenav, actionfooter and header is not visible
    // for instance if the user is not authenticated.
    layoutIsHidden: boolean;

    pageHeader: IPageHeader;
}
export interface ModuleState {
    aumicoLayout: AumicoLayoutState;
}

export const selectFeature = (state: ModuleState) => state.aumicoLayout;
export const selectActivePage = createSelector(selectFeature, (state: AumicoLayoutState) => state.activePage);

export const selectHideFooterOption = createSelector(
    selectFeature,
    (state: AumicoLayoutState) => state.hideFooterOption,
);

export const selectActiveSubNavigation = createSelector(
    selectFeature,
    (state: AumicoLayoutState) => state.activeSubNavigation,
);
export const selectSubNavigation = createSelector(selectFeature, (state: AumicoLayoutState) => state.subNavigation);

export const selectPrimaryNavigation = createSelector(
    selectFeature,
    (state: AumicoLayoutState) => state.primaryNavigation,
);
export const selectSecondaryNavigation = createSelector(
    selectFeature,
    (state: AumicoLayoutState) => state.secondaryNavigation,
);
export const selectUserNavigation = createSelector(selectFeature, (state: AumicoLayoutState) => state.userNavigation);

export const selectRouterConfig = createSelector(selectFeature, (state: AumicoLayoutState) => state.routerConfig);

export const selectUser = createSelector(selectFeature, (state: AumicoLayoutState) => state.user);

export const selectLayoutIsHidden = createSelector(selectFeature, (state: AumicoLayoutState) => state.layoutIsHidden);

export const selectShouldNavigateToRoute = createSelector(
    selectFeature,
    (state: AumicoLayoutState) => state.shouldNavigateToRoute,
);

export const selectPageHeader = createSelector(selectFeature, (state: AumicoLayoutState) => state.pageHeader);

export const initialLayoutState: AumicoLayoutState = {
    shouldNavigateToRoute: null,
    activePage: {},
    activeSubNavigation: undefined,
    previousPage: '',
    hideFooterOption: undefined,
    routerConfig: [],
    primaryNavigation: [],
    secondaryNavigation: [],
    userNavigation: undefined,
    subNavigation: [],
    user: undefined,
    layoutIsHidden: false,
    breadcrumb: 'BC',
    pageHeader: { isLocalizedKey: true, value: 'aumico_reports_default_page_header' },
};

const aumicoLayoutReducer = createReducer(
    initialLayoutState,
    on(fromActions.onShouldNavigateToRoute, (state, action) => {
        return { ...state, shouldNavigateToRoute: action.payload.route };
    }),
    on(fromActions.onPageNavigation, (state, action) => {
        return { ...state, activePage: action.payload.route };
    }),
    on(fromActions.onSubNavigation, (state, action) => {
        return { ...state, activeSubNavigation: action.payload.route };
    }),
    on(fromActions.updateSubNavigation, (state, action) => {
        /*if (state.activeSubNavigation === undefined && action.payload.items.length > 0) {
            return { ...state, subNavigation: action.payload.items, activeSubNavigation: action.payload.items[0] };
        }*/
        return { ...state, subNavigation: action.payload.items };
    }),
    on(fromActions.updateUser, (state, action) => {
        return { ...state, user: action.payload.user };
    }),
    on(fromActions.updatePrimaryNavigation, (state, action) => {
        return { ...state, primaryNavigation: action.payload };
    }),
    on(fromActions.updateSecondaryNavigation, (state, action) => {
        return { ...state, secondaryNavigation: action.payload };
    }),
    on(fromActions.updateUserNavigation, (state, action) => {
        return { ...state, userNavigation: action.payload };
    }),
    on(fromActions.initRouterConfig, (state, action) => {
        return { ...state, routerConfig: action.payload };
    }),
    on(fromActions.updateLayoutIsHidden, (state, action) => {
        return { ...state, layoutIsHidden: action.payload };
    }),
    on(fromActions.updateHideFooterOption, (state, action) => {
        return { ...state, hideFooterOption: action.payload };
    }),

    on(fromActions.resetLayout, (state) => {
        return {
            ...state,
            primaryNavigation: [],
            secondaryNavigation: [],
            subNavigation: [],
        };
    }),

    on(fromActions.changePageHeader, (state, action) => {
        return {
            ...state,
            pageHeader: action.payload,
        };
    }),
);

export function reducer(state: AumicoLayoutState | undefined, action: Action) {
    return aumicoLayoutReducer(state, action);
}
